'use strict';
define([], function() {
    function Controller($scope,$q,results,jobId, Pages, $rootScope, $translate) {
        var vm = $scope;
        vm.pages=results.data;
        vm.query='';
        vm.jobId=jobId;
        vm.pagination={
            numElements:results.totalRows,
            offset:0,
            callback: pagingCallback
        };
        vm.currentSearch={
            placeholder: $translate.instant('seospider.search.page'),
            callback: searchCallback
        };
        $rootScope.$on('languageChanged',function () {
            vm.currentSearch={
                placeholder: $translate.instant('seospider.search.page'),
                callback: searchCallback
            };
        });
        function searchCallback(query){
            vm.query=query;
            vm.pagination.offset=0;
            Pages.findAll({
                jobId:jobId,
                q:vm.query,
                status:200,
                canonicalMissing:false,
                fields:['id','url','title','canonical'],
                offset:0
            }).
            then(
                function(res){
                    vm.pagination.offset=0;
                    vm.pagination.numElements=res.totalRows;
                    vm.pages=res.data;
                },
                function(err){
                    vm.pages=err.data;
                }
            );
        }
        function pagingCallback(limit,offset){
            var dfd = $q.defer();
            Pages.findAll({
                jobId:jobId,
                q:vm.query,
                status:200,
                fields:['id','url','title','canonical'],
                canonicalMissing:false,
                limit:limit,
                offset:offset
            }).
            then(function(res){
                vm.pages=res.data;
            },function(err){
                vm.pages=err.data;
                dfd.resolve();
            });
            return dfd.promise;
        }
    }
    Controller.$inject=['$scope','$q','results','jobId','SeospiderPagesService', '$rootScope', '$translate'];
    return Controller;
});
